import categorize from './categorize.svelte';

var app = new categorize({
	target: document.querySelector('#main_content')
});

export default app;